import { Outlet, useParams, useLocation } from 'react-router-dom';
import {
    Layout, GitBranch, Target, Route as RouteIcon,
} from 'lucide-react';

const VIEW_TYPES = [
    { to: 'goal-oriented', label: 'Now-Next-Later', icon: Layout },
    { to: 'metro', label: 'Metro Map', icon: RouteIcon },
    { to: 'bold-steps', label: 'Bold Steps', icon: Target },
    { to: 'functional', label: 'Functional', icon: GitBranch },
    { to: 'goal-driven', label: 'Goal Driven', icon: Target },
];

export default function RoadmapToolkitLayout() {
    const { roadmapId } = useParams<{ roadmapId: string }>();
    const location = useLocation();

    const activeView = VIEW_TYPES.find(v => location.pathname.includes(`/${v.to}`));

    return (
        <div className="flex flex-col h-full w-full">
            {roadmapId && (
                <header className="border-b-2 border-black bg-white px-4 py-3 flex items-center gap-2 shadow-brutal shrink-0">
                    <span className="text-xs font-mono uppercase tracking-widest text-gray-400">
                        Roadmap
                    </span>
                    {activeView && (
                        <>
                            <span className="text-xs text-gray-300">/</span>
                            <span className="text-xs font-mono uppercase tracking-widest text-gray-600">
                                {activeView.label}
                            </span>
                        </>
                    )}
                </header>
            )}
            <main className="flex-1 overflow-auto bg-zinc-100">
                <Outlet context={{ onCreateClick: () => window.dispatchEvent(new CustomEvent('roadmap:create')) }} />
            </main>
        </div>
    );
}
